import React from "react";
import RequestDetailModal from "./RequestDetailModal";

const VisualIdentityModal = (props) => <RequestDetailModal {...props} />;

export default VisualIdentityModal;
